import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { ActiveDialogWFContainer } from "../../components/ActiveDialogWFContainer/ActiveDialogWFContainer";

const ActiveDialogWFScreen = () => {
  return (
    <ScreenLayout>
      <ActiveDialogWFContainer />
    </ScreenLayout>
  );
};

export default ActiveDialogWFScreen;
